module.exports = __webpack_public_path__ + "static/media/LivingClass_ordinary_001.152abeaf.png";